export default __webpack_public_path__ + "static/media/Union (4).721b1e10.svg";